import { render, staticRenderFns } from "./ConversionPercent.vue?vue&type=template&id=12face8d&scoped=true"
import script from "./ConversionPercent.vue?vue&type=script&lang=ts"
export * from "./ConversionPercent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12face8d",
  null
  
)

export default component.exports